<template>
  <div id="back">
    <div id="main">
      <!-- 导航菜单 -->
      <div>
        <el-menu
          :default-active="activeIndex2"
          class="el-menu-demo"
          mode="horizontal"
          @select="handleSelect"
          background-color="#489EE2"
          text-color="#fff"
          active-text-color="#ffd04b"
        >
          <el-menu-item index="1">监控中心</el-menu-item>
          <el-submenu index="2">
            <template slot="title">控制台</template>
            <el-menu-item index="2-1">项目</el-menu-item>
            <el-menu-item index="2-2">游戏</el-menu-item>
            <el-menu-item index="2-3">网关</el-menu-item>
            <el-submenu index="2-4">
              <template slot="title">服务器</template>
              <el-menu-item index="2-4-1">windows Service</el-menu-item>
              <el-menu-item index="2-4-2">linux</el-menu-item>
              <el-menu-item index="2-4-3">mac</el-menu-item>
            </el-submenu>
          </el-submenu>
          <el-menu-item index="3" disabled>消息中心</el-menu-item>
        </el-menu>
      </div>
      <!-- 登录按钮 -->
      <div id="login">
        <el-button
          type="text"
          @click="dialogFormVisible = true"
          style="float:right;margin-right:10px;color:#fff;padding-top:2px;padding-bottom:2px;"
        >管理员登录
        </el-button>
      </div>
      <!-- 登录弹窗 -->
      <div>
        <el-dialog title="管理员登录" :visible.sync="dialogFormVisible" center width="300px">
          <el-form
            :model="form"
            :rules="rules"
            ref="form"
            label-width="90px"
            label-position="left"
            size="small"
          >
            <el-form-item label="账号" prop="name">
              <el-input v-model="form.name"></el-input>
            </el-form-item>
            <el-form-item label="密码" prop="password">
              <el-input v-model="form.password" type="password"></el-input>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="dialogFormVisible = false" size="small">取 消</el-button>
            <el-button type="primary" @click="login('form')" size="small">登录</el-button>
          </div>
        </el-dialog>
      </div>
      <!-- 轮播图 -->
      <!--      <div id="banner">-->
      <!--        <el-carousel height="200px" class="bannerImg">-->
      <!--          <el-carousel-item v-for="url in bannerData" :key="url">-->
      <!--            &lt;!&ndash; <h3 class="small">{{ item }}</h3> &ndash;&gt;-->
      <!--            <el-image :src="url" :fit="fill" class="bannerImg"></el-image>-->
      <!--          </el-carousel-item>-->
      <!--        </el-carousel>-->
      <!--      </div>-->
      <!--导航-->
      <div id="root">
        <h3>开发中..</h3>
      </div>
      <!-- 底部备案信息 -->
      <div id="footer">
        <div style="width: 150px;margin: 0 auto;">
          <a href="http://beian.miit.gov.cn" id="ICP" target="_blank">闽ICP备18022285号</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
    export default {
        name: "App",
        data() {
            return {
                dialogTableVisible: false,
                dialogFormVisible: false,
                form: {
                    name: "",
                    password: ""
                },
                rules: {
                    name: [
                        {required: true, message: "请输入账号", trigger: "blur"},
                        {min: 3, max: 10, message: "长度在 3 到 10 个字符", trigger: "blur"}
                    ],
                    password: [
                        {required: true, message: "请输入密码", trigger: "blur"},
                        {min: 6, max: 16, message: "长度在 6 到 16 个字符", trigger: "blur"}
                    ]
                },
                bannerData: [
                    "http://img2.imgtn.bdimg.com/it/u=3080247459,543155867&fm=26&gp=0.jpg",
                    "http://img2.imgtn.bdimg.com/it/u=3871685348,339319290&fm=26&gp=0.jpg",
                    "http://img2.imgtn.bdimg.com/it/u=3267623076,2064774942&fm=11&gp=0.jpg",
                    "http://img1.imgtn.bdimg.com/it/u=415462541,1442358230&fm=26&gp=0.jpg"
                ]
            };
        },
        methods: {
            login(formName) {
                this.$refs[formName].validate(valid => {
                    if (valid) {
                        this.$message({
                            type: "error",
                            message: "帐号不存在"
                        });
                    } else {
                    }
                });
            },
            handleSelect() {
                this.$message({
                    type: "info",
                    message: "权限不足"
                });
            }
        }
    };
</script>

<style>
  #back {
    width: 100%;
    background: url("../../static/header.png");
    background-repeat: repeat-x;
  }

  #main {
    width: 960px;
    height: 600px;
    margin: 0 auto;
    position: relative;
  }

  #login {
    width: 960px;
    height: 20px;
    margin: 0 auto;
    background: rgb(42, 141, 219);
  }

  #root {
    width: 100%;
    height: 100%;
    background-color: white;
  }

  #banner {
    width: 960px;
    margin: 0 auto;
  }

  .bannerImg {
    width: 960px;
    height: 200px;
    margin: 0 auto;
  }

  #footer {
    width: 960px;
    margin: 0 auto;
    background-color: #2c3e50;
    position: fixed;
    bottom: 0;
  }

  #ICP {
    color: #999;
    text-align: center;
  }

  .hotnews {
    font-size: 12px;
    color: #222
  }
</style>



// WEBPACK FOOTER //
// src/components/HelloWorld.vue